export enum ThresholdKinds {
  USERS = "USERS",
  ENTRIES = "ENTRIES",
  FORMS = "FORMS",
  KANBANS = "KANBANS",
  CUSTOM_FIELDS = "CUSTOM_FIELDS",
  MOBILE_APP = "MOBILE_APP",
  MODULES_DEFINITIONS = "MODULES_DEFINITIONS",
}
